

















import { Component, Vue, Prop} from 'vue-property-decorator';
import * as Components from '@/tenant/components';
import * as Common from '@/tenant/common';


@Component
export default class AtcCommodity extends Vue {
  @Prop({ default: '' }) public title: string;
  @Prop({ default: null }) public value?: any | Common.IMasterItem;
  @Prop({ default: false }) public required: boolean;
  @Prop({ default: null }) public editor: Components.IEditor;
  @Prop({ default: true }) public enabled: boolean;
  @Prop({ default: false }) public listMode: boolean; //Conversionで使用するために変更
  @Prop({ default: true }) public linkOnNewTab: boolean;
  @Prop() public tooltip: string;

  public warehouse: Common.Counterpart = null;
  public isEdit: boolean = true;
  public validator: Components.ControlValidator = null;
  public query: string = null;
  public list :string = null;
  public showPopover :boolean = false;
  public target: HTMLElement = null;

  public created() {
    //親Editorに登録する
    if (this.editor != null) this.editor.addControl(this);
    //this.query = this.value;    
    if (this.listMode) this.list = "commodity";
    else this.query = 'CommodityMasterQuery';
  }
  destroyed(){
    if (this.editor != null) this.editor.removeControl(this);    
  }  
  public get internalValue(): string {
    return this.value;
  }

  public set internalValue(value: string) {
    // 親コンポーネント側で更新
    this.$emit('update:value', value);
    this.$emit('changed');
  }

  public onLinkClicked(event: Event){
      //listModeは使用されていない。linkOnNewTabはセット品・構成品・荷姿・単価・SKUで親商品に遷移するために使用されている
      
      if (this.listMode){
        //リストモードの場合はidが格納されているのでコードに変換する必要がある
        this.$api.formatter.formatByListAjax(this.value,"commodityCode").then(result =>{
          if (this.linkOnNewTab){
            let routeData = this.$router.resolve(String.format('/master/Commodity?auditNo={0}', result));
            window.open(routeData.href, '_blank');          
          } else {
            this.$router.push(String.format('/master/Commodity?auditNo={0}', result)); 
          }
         
        });
      }  else {
          if (this.linkOnNewTab){
            this.onPopupClicked();
            // let routeData = this.$router.resolve(String.format('/master/Commodity?auditNo={0}', (this.value as Common.Commodity).code));
            // window.open(routeData.href, '_blank');    
          } else {
            this.$router.push(String.format('/master/Commodity?auditNo={0}', (this.value as Common.Commodity).code));   
          }
      }
   
  }

  public onFuncClicked(event: Event){
    //targetとなるボタン
    this.target = event.srcElement as HTMLElement;
    if (this.showPopover) this.showPopover = false;
    else this.showPopover = true;    
  }

  public showEditor = false;
  public onPopupClicked(){
    this.showEditor = true;
  }  
  public onEditorClosing(arg : any){
    var obj = ((this.$refs.editor as Components.Commodity).$refs.mainList as Components.ListView).selected;
    if (obj.id == 0) return; //未保存の場合はキャンセル可
    if ((obj as Common.MasterBase).state != Common.MasterBaseStatus.Posted) {
      arg.canceled = true;
      this.$api.modal.show('無効な操作','編集画面を閉じる前に確定してください。', true,null);      
      return;
    }
    //オブジェクトを更新する
    this.$emit('update:value', obj);    
  }  
}
  
